<template>
    <div data-v-6ebeef4c>
        <usertop></usertop>
        <div data-v-1c9f1659="">
            <div data-v-1c9f1659="" class="el-col el-col-24">
                <div data-v-1c9f1659="" class="el-card is-never-shadow">
                    <div class="el-card__body" style="padding: 16px; text-align: left;">
                        <div data-v-1c9f1659="" class="G-title"><span data-v-1c9f1659="">我的信息</span></div>
                        <div data-v-1c9f1659="" style="margin: 20px;">
                            <div data-v-1c9f1659=""
                                class="el-table el-table--fit el-table--border el-table--enable-row-hover"
                                style="margin: auto;">
                                <div class="hidden-columns">
                                    <div data-v-1c9f1659=""></div>
                                    <div data-v-1c9f1659=""></div>
                                    <div data-v-1c9f1659=""></div>
                                    <div data-v-1c9f1659=""></div>
                                    <div data-v-1c9f1659=""></div>
                                    <div data-v-1c9f1659=""></div>
                                </div>
                                <div class="el-table__header-wrapper">
                                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__header"
                                        style="width: 1045px;">
                                        <colgroup>
                                            <col name="el-table_2_column_5" width="515">
                                            <col name="el-table_2_column_6" width="180">
                                            <col name="el-table_2_column_7" width="100">
                                            <col name="el-table_2_column_8" width="80">
                                            <col name="el-table_2_column_9" width="70">
                                            <col name="el-table_2_column_10" width="100">
                                            <col name="gutter" width="0">
                                        </colgroup>
                                        <thead class="has-gutter">
                                            <tr class="">
                                                <th colspan="1" rowspan="1" class="el-table_2_column_5     is-leaf">
                                                    <div class="cell">标题</div>
                                                </th>
                                                <th colspan="1" rowspan="1" class="el-table_2_column_6     is-leaf">
                                                    <div class="cell">地区</div>
                                                </th>
                                                <th colspan="1" rowspan="1" class="el-table_2_column_7     is-leaf">
                                                    <div class="cell">状态</div>
                                                </th>
                                                <th colspan="1" rowspan="1" class="el-table_2_column_8     is-leaf">
                                                    <div class="cell">获得积分</div>
                                                </th>
                                                <th colspan="1" rowspan="1" class="el-table_2_column_9     is-leaf">
                                                    <div class="cell">浏览</div>
                                                </th>
                                                <th colspan="1" rowspan="1" class="el-table_2_column_10     is-leaf">
                                                    <div class="cell">日期</div>
                                                </th>
                                                <th class="gutter" style="width: 0px; display: none;"></th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div class="el-table__body-wrapper is-scrolling-none">
                                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body"
                                        style="width: 1045px;">
                                        <colgroup>
                                            <col name="el-table_2_column_5" width="515">
                                            <col name="el-table_2_column_6" width="180">
                                            <col name="el-table_2_column_7" width="100">
                                            <col name="el-table_2_column_8" width="80">
                                            <col name="el-table_2_column_9" width="70">
                                            <col name="el-table_2_column_10" width="100">
                                        </colgroup>
                                        <tbody>
                                            <tr v-for="v in mydata" class="el-table__row">
                                                <td rowspan="1" colspan="1"
                                                    class="el-table_1_column_1   el-table__cell">
                                                    <div class="cell"><a :href="'show?id='+v.id" target="_blank" style="color: #666;">{{v.title}}</a></div>
                                                </td>
                                                <td rowspan="1" colspan="1"
                                                    class="el-table_1_column_2   el-table__cell">
                                                    <div class="cell">{{v.dz}}</div>
                                                </td>
                                                <td rowspan="1" colspan="1"
                                                    class="el-table_1_column_3   el-table__cell">
                                                    <div class="cell" v-if="v.status==1">审核中</div>
                                                    <div class="cell" v-if="v.status==0">正常</div>
                                                </td>
                                                <td rowspan="1" colspan="1"
                                                    class="el-table_1_column_3   el-table__cell">
                                                    <div class="cell">0</div>
                                                </td>
                                                <td rowspan="1" colspan="1"
                                                    class="el-table_1_column_3   el-table__cell">
                                                    <div class="cell">{{v.browse}}</div>
                                                </td>
                                                <td rowspan="1" colspan="1"
                                                    class="el-table_1_column_3   el-table__cell">
                                                    <div class="cell">{{v.create_time}}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-if="nodata==1" class="el-table__empty-block" style="height: 100%; width: 1045px;"><span class="el-table__empty-text">暂无数据</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div data-v-1c9f1659="" class="el-col el-col-24">
                <div data-v-1c9f1659="" class="el-card is-never-shadow" style="margin: 0px;">
                    <div class="el-card__body" style="margin: 20px;">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :pager-count="5"
                        @current-change="pageclick"
                        :page-size="24"
                        :current-page=currentpage
                        >
                    </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'myinfos',
    data() {
        return {
            mydata:[],
            total:0,
            currentpage:1,
            nodata:1,
        }
    },
    methods:{
        pageclick(pp){
            
            window.location.href = 'myinfo?page='+pp

            this.currentpage = pp

        }
    },
    mounted() {

        let page = this.$route.query.page

        console.log(page)

        this.$http.post('/api/myinfo',{page:page}).then(res=>{

            if(res.data.data){

                this.mydata = res.data.data

                this.total = res.data.count

                this.currentpage = Number(page)

                this.nodata = 0

            }else{

                this.mydata = 1

                this.nodata = 1

            }

        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/myinfos.vue